/** @format */

import {Box, ButtonBase, TextField} from '@mui/material';
import {styled} from '@mui/material/styles';

export const PickerPaper = styled(Box)(({theme}) => ({
  width: 560,
  backgroundColor: 'white',
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
  overflow: 'hidden',
}));

export const PickerSearch = styled(TextField)(({theme}) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    borderRadius: theme.spacing(2),
    '& fieldset': {
      borderColor: theme.palette.figma_gray_middle?.main,
    },
    '&:hover fieldset': {
      borderColor: '#C0C0C0',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#B0B0B0',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(2.5, 4),
    color: '#333',
  },
}));

export const PickerList = styled(Box)(() => ({
  maxHeight: 360,
  overflow: 'auto',
  backgroundColor: 'white',
}));

export const PickerRow = styled(ButtonBase)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '220px 1fr',
  gap: theme.spacing(4),
  padding: theme.spacing(3, 4),
  borderTop: '1px solid #EFEFEF',
  width: '100%',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: '#F6F6F6',
  },
}));

export const PickerLeft = styled(Box)(({theme}) => ({
  borderRight: '1px solid #E9E9E9',
  paddingRight: 16,
  color: theme.palette.figma_gray_dark?.main,
}));

export const PickerRight = styled(Box)(({theme}) => ({
  color: theme.palette.figma_gray_dark?.main,
}));
